import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'hybse-admin-kyc-approve-reject',
  templateUrl: './kyc-approve-reject.component.html',
  styleUrls: ['./kyc-approve-reject.component.css']
})
export class KycApproveRejectComponent implements OnInit {

  public kycData: any

  constructor(public dialogRef: MatDialogRef<KycApproveRejectComponent>, @Inject(MAT_DIALOG_DATA) public data: any) {

    this.kycData = data.data;
  }

  ngOnInit() {
    this.dialogRef.updatePosition({ top: '100px', left: '25%' });
  }

  public onClick(status: string): void {
    this.dialogRef.close({
      data:status
    });
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/pages/kyc/kyc-approve-reject.component.ts